import React, { Component } from 'react';
//import swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import * as Actions from '../../Actions/AdhActions';
import{ connect } from 'react-redux';

class AlerteInfoPremiereCnx extends Component {
    constructor() {
        super();
    }

    // componentWillMount(){
    //     const PremiereCnx = this.props.PremiereCnx
    //     if(PremiereCnx) swal('Bienvenue sur votre extranet de copropriété !', 'Une question sur l\'utilisation de votre espace ? Pensez à l\'aide en ligne !', 'info');
    // }

    SetProps = () => {
        this.props.actions.comprisAide()
    }

    render() {
        const PremiereCnx = this.props.PremiereCnx
        return (!PremiereCnx ? null : (
             <div className="card alert-info mb-3">
                 <div className="card-body">
                     <h5 className="card-title">
                         Bienvenue sur votre extranet de copropriété !
                     </h5>
                     <p className="card-text">
                         Tout au long de votre navigation, si vous souhaitez en apprendre d'avantage sur l'utilisation du site ou si vous vous questionnez sur son fonctionnement,
                         le bouton d'aide <i className="fa fa-lg fa-question-circle" /> se trouve à portée de clic à tout moment.
                         {/* Une question sur l'utilisation de votre espace ? Pensez à l'aide en ligne ! */}
                         <a href="#" onClick={this.SetProps} className="btn btn-info float-right mt-3">D'accord</a>
                     </p>
                 </div>
             </div>
        ));
    }
}


function mapStateToProps({
    AdhStore: {
        Adh: { PremiereCnx },
    },
}) {
    return { PremiereCnx };
}

function mapDispatchToProps(dispatch) {
    return { actions: bindActionCreators(Actions, dispatch) };
}

export default connect(mapStateToProps, mapDispatchToProps)(AlerteInfoPremiereCnx);


// WEBPACK FOOTER //
// ./src/components/Accueil/AlertePremiereCnx.js